import { Controller } from "@hotwired/stimulus"

// 都道府県の索引にホバー / フォーカスしている間、地図のその県を濃くする
export default class extends Controller {
  connect() {
    // 県名 / 現在地のタブには地図が無い
    this.svgElement = this.element.querySelector(".japan-map-svg svg")
  }

  highlight({ params: { code } }) {
    this.svgElement?.querySelectorAll(`path[data-code="${code}"]`).forEach(path => path.classList.add("is-highlighted"))
  }

  unhighlight({ params: { code } = {} } = {}) {
    const selector = code ? `path.is-highlighted[data-code="${code}"]` : "path.is-highlighted"
    this.svgElement?.querySelectorAll(selector).forEach(path => path.classList.remove("is-highlighted"))
  }
}
